import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'src/client/js/view/components/Grid';
import Button from 'wonderbly-components/lib/Button';
import { getBingAccessKey } from 'src/common/config/bing';
import Microsoft from './Microsoft';
import './BingMap.scss';

export class BingMap extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    onAbandonMap: PropTypes.func.isRequired,
    onMapMove: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    cta: PropTypes.string.isRequired,
    editAddress: PropTypes.string.isRequired
  };

  viewChanged = null;
  microsoft = new Microsoft();

  componentDidMount() {
    const bingMapsUrl = 'https://www.bing.com/api/maps/mapcontrol';
    let bingMapsScript = document.querySelector(`[src="${bingMapsUrl}"]`);
    if (!bingMapsScript) {
      bingMapsScript = document.createElement('script');
      bingMapsScript.src = bingMapsUrl;
      bingMapsScript.async = true;
      bingMapsScript.defer = true;
      const head = document.getElementsByTagName('head')[0];
      head.appendChild(bingMapsScript);
    }

    // creating a closure here so I can use `async` in a sync method
    const generateMap = async () => {
      const map = await this.generateMap();
      this.viewChanged = await this.microsoft.addEventHandler(
        map,
        'viewchangeend',
        () => {
          const center = map.getCenter();
          const lat = center.latitude;
          const lng = center.longitude;
          this.props.onMapMove({ lat, lng });
        }
      );
    };
    // no one cares whether this resolves or not, so not doing anything with this promise
    generateMap();
  }

  componentWillUnmount() {
    // no one cares whether this resolves or not, so not doing anything with this promise
    this.microsoft.removeEventHandler(this.viewChanged);
  }

  generateStartPoint = () => this.microsoft.getLocation(
    this.getMapOptions().lat,
    this.getMapOptions().lng
  );

  generateMap = async () => {
    const mapTypeId = await this.microsoft.getArial();
    const center = await this.generateStartPoint();
    return this.microsoft.getMap(this._map, {
      credentials: getBingAccessKey(),
      center: center,
      mapTypeId: mapTypeId,
      disableBirdseye: true,
      zoom: this.getMapOptions().zoom,
      showDashboard: false,
      disableZooming: true,
      enableSearchLogo: false
    });
  };

  getMapOptions = () => ({
    lat: this.props.lat,
    lng: this.props.lng,
    zoom: this.props.lat ? 16 : 10
  });

  handleEditAddressClick = () => {
    this.props.onAbandonMap();
  };

  handleSave = () => {
    this.props.onSave(this.props.lat, this.props.lng);
  };

  setMapRef = map => {
    this._map = map;
  };

  render() {
    return (
      <div>
        <div className="home-map">
          <div className="home-map-preview" ref={this.setMapRef}/>
          <div className="home-map-target"/>
        </div>
        <Row colsToRowsOn="mobile" className="home-map-navigation">
          <Col>
            <span
              className="home-map-edit cursor-pointer color-green"
              onClick={this.handleEditAddressClick}>
              <i className="ss-directleft"/>
              {this.props.editAddress}
            </span>
          </Col>
          <Col className="home-map-button">
            <Button
              type="button"
              colour="green"
              onClick={this.handleSave}
              className="widest-on-fablet-down"
              data-hook="map-preview-save-cta"
              raised>
              {this.props.cta}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default BingMap;
